import { createContext } from "react";
import { FetcherWithComponents } from "react-router";

export type InternalFormContextValue = {
  formId: string | symbol;
  action?: string;
  subaction?: string;
  defaultValuesProp?: { [fieldName: string]: any };
  fetcher?: FetcherWithComponents<unknown>;
};

export const InternalFormContext =
  createContext<InternalFormContextValue | null>(null);
